import React from "react";
import ReactHtmlParser from "@/src/utils/html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import { Box, Link, Typography } from "@mui/material";
import type Correspondence from "@/src/_types/Authors/correspondence";
import NextLink from "next/link";

const AuthorCorrespondence = ({
  correspondences,
  hasEqualContributer,
  isDeceased,
  authorNoteFnEqual,
}: {
  correspondences: Correspondence[];
  hasEqualContributer: boolean;
  isDeceased: boolean;
  authorNoteFnEqual: string;
}) => {
  return (
    <Box sx={{
      color: "text.primary",
      fontSize: ".875rem"
    }}>
      {correspondences.length === 1 ? (
        correspondences.map((correspondence: Correspondence, index: number) => (
          <Box
            key={`${correspondence.id || `correspondence-${index}`}`}
            id={`${correspondence.id || `correspondence-${index}`}`}
          >
            <SpanTypography variant="inherit">{correspondence.label}</SpanTypography>
            <SpanTypography variant="inherit">
              {!correspondence.content.startsWith("Corresponding Author") &&
                "Corresponding Author: "}
            </SpanTypography>
            <SpanTypography variant="inherit">
              {ReactHtmlParser(correspondence.content)}
            </SpanTypography>
            <SpanTypography variant="inherit">
              {!correspondence.content.includes("Email:") && " Email: "}
            </SpanTypography>
            {correspondence.email &&
              correspondence.email !== "" &&
              correspondence.email
                .split(";")
                .map((mail: string, index: number) => (
                  <React.Fragment key={mail}>
                    <Link
                      component={NextLink}
                      href={`mailto:${mail}`}
                      sx={{ fontSize: "inherit" }}
                    >
                      {mail}
                    </Link>
                    {index < correspondence.email.split(";").length - 1 && "; "}
                  </React.Fragment>
                ))}
          </Box>
        ))
      ) : correspondences.length === 0 ? (
        <Typography variant="inherit" component="p">
          Warning: No corresponding author defined!
        </Typography>
      ) : (
        <>
          <Typography
            component="b"
            variant="inherit"
            sx={{
              fontWeight: 700
            }}>
            Corresponding Authors:
          </Typography>
          {correspondences.map(
            (correspondence: Correspondence, index: number) => (
              <Box
                key={`${correspondence.id || `correspondence-${index}`}`}
                id={`${correspondence.id || `correspondence-${index}`}`}
              >
                <SpanTypography variant="inherit">{correspondence.label}</SpanTypography>
                <SpanTypography variant="inherit">
                  {ReactHtmlParser(
                    correspondence.content.startsWith("Corresponding author:")
                      ? correspondence.content.slice(
                          "Corresponding author:".length,
                        )
                      : correspondence.content,
                  )}
                </SpanTypography>
                {correspondence.email && correspondence.email !== "" && (
                  <Link
                    component={NextLink}
                    href={`mailto:${correspondence.email}`}
                    sx={{ fontSize: "inherit" }}
                  >
                    <SpanTypography variant="inherit">
                      {correspondence.email}
                    </SpanTypography>
                  </Link>
                )}
              </Box>
            ),
          )}
        </>
      )}
      {(hasEqualContributer || isDeceased) && (
        <Typography variant="inherit" component="p">
          {authorNoteFnEqual
            ? authorNoteFnEqual
            : !authorNoteFnEqual &&
              !isDeceased &&
              "# These authors have contributed equally."}
        </Typography>
      )}
    </Box>
  );
};

export default AuthorCorrespondence;
